export default __webpack_public_path__ + "static/media/rob_balasabas.fef84dd0.png";